<div class="bg-overlay-modal flex flex-col max-h-[calc(100vh-2px)] overflow-y-auto overflow-x-hidden">
  <button
    [attr.aria-label]="'cl_chat.close' | translate"
    class="bg-content absolute right-4 top-4 h-8 w-8 border-0 rounded-full cursor-pointer hover:bg-blue-500/5 focus-visible:outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)]"
    (click)="cancelClick()"
    data-e2e="base-modal-close-button"
  >
    <i class="mi2-close text-[16px] text-surface-600"></i>
  </button>

  @if (title()) {
    <h2
      id="chat-confirmation-dialog-title"
      class="font-semibold text-[22px] pt-8 pl-8 text-left w-min min-w-full mb-0 flex-shrink-0"
    >
      {{ title() }}
    </h2>
  }

  @if (bodyText()) {
    <div class="text-color pt-6 pr-[27px] pb-2 pl-8 text-lg leading-[21px]" [innerHTML]="bodyText()"></div>
  }

  @if (item()) {
    <div class="relative max-w-[513px] overflow-y-auto flex-grow">
      <div class="rounded-2xl border border-surface-100 m-4 p-2 pb-3">
        <chat-item
          [item]="item()"
          [isContinuation]="false"
          [maxImageSize]="maxImageSize()"
          [dateTimeLocale]="dateTimeLocale()"
          [previewMode]="true"
        >
        </chat-item>
      </div>
    </div>
  }

  @if (file()) {
    <div class="relative max-w-[513px] overflow-y-auto flex-grow my-0 mx-[31px]">
      <div class="flex rounded-2xl border border-surface-100 p-4">
        <div class="flex-shrink-0 ml-2 mr-2">
          <mi-attachment-icon [attachmentName]="file().name" class="scale-[0.88]"></mi-attachment-icon>
        </div>
        <div class="flex-grow overflow-hidden">
          <div
            class="text-sm overflow-hidden whitespace-nowrap text-ellipsis pb-0.5 text-color"
            title="{{ getAttachmentDisplayName(file()) }}"
          >
            {{ getAttachmentDisplayName(file()) }}
          </div>
          <div class="pt-1 text-xs font-semibold overflow-hidden whitespace-nowrap text-ellipsis text-muted-color">
            {{
              'cl_chat.attachmentDate'
                | translate
                  : {
                      date: file()?.dateString,
                      user: chatAdminService.displayNames[file()?.createdBy] || file()?.createdBy
                    }
            }}
          </div>
        </div>
      </div>
    </div>
  }

  @if (currentLocation()) {
    <div class="relative max-w-[513px] overflow-y-auto flex-grow mt-5 mx-[31px] mb-0">
      <app-location-card
        [showLocation]="true"
        [isOfflineCache]="false"
        [latitude]="currentLocation()?.coords?.latitude"
        [longitude]="currentLocation()?.coords?.longitude"
        [isMine]="true"
      >
      </app-location-card>
    </div>
  }

  <div class="flex flex-row justify-end w-full p-8 flex-shrink-0">
    <button
      #cancelButton
      class="mr-2 py-2.5 px-[30px] chat-one-app-button modal-button"
      [ngClass]="primeThemeService.isDarkMode() ? 'primary-dark' : 'primary-grey'"
      (click)="cancelClick()"
    >
      {{ cancelButtonText() }}
    </button>
    <button
      class="chat-delete-button chat-one-app-button modal-button"
      (click)="okClick()"
      data-e2e="ok-button"
      [ngClass]="{ 'primary-red': !currentLocation(), 'primary-blue': currentLocation() }"
      [ngStyle]="{ 'box-shadow': 'var(--p-mi-shadow)' }"
    >
      {{ okButtonText() }}
      @if (currentLocation()) {
        <i class="mi2-send text-[17px] text-surface-0 ml-1.5"></i>
      }
    </button>
  </div>
</div>
